// Extending the Glide component so that only visible slides can be identified with an extra class and can be tabbed to

export function Visible(Glide, Components, Events) {
        
    var Component = {

        mount () {
            this.removeVisible();
            this.setVisible();
        },

        removeVisible() {

            Components.Html.root.querySelectorAll('.glide__slide--visible').forEach(slide => {
                slide.classList.remove('glide__slide--visible');
            });

            Components.Html.root.querySelectorAll('a:not([tabindex]').forEach(link => {
                link.setAttribute("tabindex", -1);
            });

        },

        setVisible () {
            
            if (Glide.settings.perView > 1) {
                
                const glideEl = Components.Html.root;
                const active = Components.Html.slides[Glide.index];

                // Calculate how many on each side we need to add visible classes to
                if (Glide.settings.focusAt === 'center') {
                    var numBefore = Math.ceil((Glide.settings.perView - 1) / 2);
                    var numAfter = numBefore;
                } else {
                    var numBefore = Glide.settings.focusAt;
                    var numAfter = Glide.settings.perView - Glide.settings.focusAt - 1;
                }

                // Add visible class
                active.classList.add('glide__slide--visible');

                // Remove -1 tabindex
                active.querySelector('a').removeAttribute('tabindex');
                
                if (numAfter) {
                    
                    // Add visible classes and tabindex to next siblings
                    var next = active;

                    for (let i = 0; i < numAfter; i++) {

                        next = next.nextElementSibling;

                        if (next) {

                            // Add visible class
                            next.classList.add('glide__slide--visible');

                            // Remove -1 tabindex
                            next.querySelector('a').removeAttribute('tabindex');
                            
                        }
                        
                    }

                }

            } else {
                
                // Add visible class
                Components.Html.slides[Glide.index].classList.add('glide__slide--visible');

                // Remove tab index
                Components.Html.slides[Glide.index].querySelector('a').removeAttribute('tabindex');

            }

        }

    };

    Events.on('run.before', () => {
        Component.removeVisible();
    });

    Events.on('run.after', () => {
        Component.setVisible();
    });

    Events.on('resize', () => {
        Component.removeVisible();
        Component.setVisible();
    });

    return Component;

};

// Extending the Glide component so that a transition class is added when slides are being transitioned

export function TransitionClass(Glide, Components, Events) {
        
    var Component = {

        addTransitionClass () {
          
            const rootEl = Components.Html.root;

            rootEl.classList.add("glide--transitioning");

        },

        removeTransitionClass () {
            
            const rootEl = Components.Html.root;

            rootEl.classList.remove("glide--transitioning");

        }

    };

    Events.on('move', () => {
        Component.addTransitionClass();
    });

    Events.on('move.after', () => {
        Component.removeTransitionClass();
    });

    return Component;

};

// Extending the Glide component so that video modal is opened when video image thumbnail is clicked in the slide

export function VideoModal(Glide, Components, Events) {
        
    var Component = {

        mount () {
            this.blindButtonClickToOpenVideoModal();
        },

        closeVideoModal () {
          
            let activeVideoModal = Components.Html.root.querySelector('.video-modal:not([hidden])');

            if (activeVideoModal) {
                activeVideoModal.closest(".video-modal-wrapper").modal.closeModal();
            }

        },

        blindButtonClickToOpenVideoModal () {
            
            Components.Html.root.querySelectorAll('[data-video-modal-target]').forEach(button => {
                
                let target = button.getAttribute("data-video-modal-target");

                let videoModal = document.getElementById(target);

                if (videoModal) {

                    button.addEventListener("click", function() {
                    
                        videoModal.modal.openModal();

                    });

                }
                
            });

        }

    };

    Events.on('resize', () => {
        
        // If modal is not closed when resizing, the width calculation of the slideshow will be inaccurate
        // Best to close the video modal (if opened) when resizing
        Component.closeVideoModal();
        
    });

    return Component;

};

// If there's only 1 slide, disable carousel 
export function DisableIfSingleSlide(Glide, Components, Events) {

    var Component = {

        mount () {

            if (Components.Sizes.length < 2) {
                
                Glide.disable();

            }

        }

    };

    return Component;

}

export function PeekClick(Glide, Components, Events) {

    


};